export const PERMISSION_TYPES = {
  ALL: 'all',
  VIEW: 'view',
  CREATE: 'create',
  EDIT: 'edit',
  DELETE: 'delete',
  EXCEL: 'excel',
  PRINT: 'print',
  ADMIN: 'admin',
}

export const DEFAULT_PERMISSIONS = {
  [PERMISSION_TYPES.ALL]: false,
  [PERMISSION_TYPES.VIEW]: false,
  [PERMISSION_TYPES.CREATE]: false,
  [PERMISSION_TYPES.EDIT]: false,
  [PERMISSION_TYPES.DELETE]: false,
  [PERMISSION_TYPES.EXCEL]: false,
  [PERMISSION_TYPES.PRINT]: false,
  [PERMISSION_TYPES.ADMIN]: false,
}

export const createFunction = (id, name, legacyMappings = {}) => ({
  id,
  name,
  permissions: { ...DEFAULT_PERMISSIONS },
  legacyMappings,
})

export const PERMISSION_LABELS = {
  [PERMISSION_TYPES.ALL]: 'Tất cả',
  [PERMISSION_TYPES.VIEW]: 'Xem',
  [PERMISSION_TYPES.CREATE]: 'Tạo',
  [PERMISSION_TYPES.EDIT]: 'Sửa',
  [PERMISSION_TYPES.DELETE]: 'Xóa',
  [PERMISSION_TYPES.EXCEL]: 'Excel',
  [PERMISSION_TYPES.PRINT]: 'Print',
  [PERMISSION_TYPES.ADMIN]: 'Admin',
}

export const MODULES = {
  CATEGORY: 'category',
  CUSTOMER: 'customer',
  STOCK: 'stock',
  ORDER: 'order',
  SALES: 'sales',
  WARRANTY: 'warranty',
  TRADEIN: 'tradein',
  ACCOUNTING: 'accounting',
  REPORT: 'report',
  REWARD: 'reward',
  PLATFORM: 'platform',
  CONFIG: 'config',
}

export const MODULE_NAME = Object.freeze({
  [MODULES.CATEGORY]: 'Danh mục',
  [MODULES.CUSTOMER]: 'KH-NCC',
  [MODULES.STOCK]: 'Kho hàng',
  [MODULES.ORDER]: 'Đơn hàng',
  [MODULES.SALES]: 'Bán hàng',
  [MODULES.WARRANTY]: 'Bảo hành',
  [MODULES.ACCOUNTING]: 'Kế toán',
  [MODULES.TRADEIN]: 'Thu cũ',
  [MODULES.REWARD]: 'Hoa hồng',
  [MODULES.REPORT]: 'Báo cáo',
  [MODULES.CONFIG]: 'Cấu hình',
  [MODULES.PLATFORM]: 'Kênh bán',
})

export const PERMISSION_MATRIX = {
  [MODULES.CATEGORY]: [
    {
      group: 'Sản phẩm',
      functions: [
        createFunction('productManagement', 'Quản lý sản phẩm', {
          [PERMISSION_TYPES.VIEW]: 'productView',
          [PERMISSION_TYPES.CREATE]: 'productInsert',
          [PERMISSION_TYPES.EDIT]: 'productUpdate',
          [PERMISSION_TYPES.DELETE]: 'productDelete',
        }),
        createFunction('productOriginalPriceView', 'Giá nhập', {
          [PERMISSION_TYPES.VIEW]: 'productOriginalPriceView',
        }),
        createFunction('productVatUpsert', 'Thông tin VAT', {
          [PERMISSION_TYPES.ADMIN]: 'productVatUpsert',
        }),
        createFunction('productUpdatePrice', 'Quản lý giá', {
          [PERMISSION_TYPES.EDIT]: 'productUpdatePrice',
        }),
      ],
    },
    {
      group: 'Danh mục sản phẩm',
      functions: [
        createFunction('categoryManagement', 'Quản lý danh mục sản phẩm', {
          [PERMISSION_TYPES.VIEW]: 'cateView',
          [PERMISSION_TYPES.CREATE]: 'cateInsert',
          [PERMISSION_TYPES.EDIT]: 'cateUpdate',
          [PERMISSION_TYPES.DELETE]: 'cateDelete',
        }),
        createFunction('cateMergeManagement', 'Gộp danh mục', {
          [PERMISSION_TYPES.ADMIN]: 'cateMerge',
        }),
        createFunction('cateMoveManagement', 'Di chuyển danh mục', {
          [PERMISSION_TYPES.ADMIN]: 'cateMove',
        }),
      ],
    },
    {
      group: 'Danh mục linh kiện',
      functions: [
        createFunction('productComponentCateManagement', 'Danh mục linh kiện', {
          [PERMISSION_TYPES.VIEW]: 'productComponentCateView',
          [PERMISSION_TYPES.CREATE]: 'productComponentCateInsert',
          [PERMISSION_TYPES.EDIT]: 'productComponentCateUpdate',
          [PERMISSION_TYPES.DELETE]: 'productComponentCateDelete',
        }),
      ],
    },
    {
      group: 'Linh kiện',
      functions: [
        createFunction('productComponentManagement', 'Linh kiện', {
          [PERMISSION_TYPES.VIEW]: 'productComponentView',
          [PERMISSION_TYPES.CREATE]: 'productComponentInsert',
          [PERMISSION_TYPES.EDIT]: 'productComponentUpdate',
          [PERMISSION_TYPES.DELETE]: 'productComponentDelete',
        }),
      ],
    },
    {
      group: 'Thương hiệu',
      functions: [
        createFunction('brandManagement', 'Quản lý thương hiệu', {
          [PERMISSION_TYPES.VIEW]: 'brandView',
          [PERMISSION_TYPES.CREATE]: 'brandInsert',
          [PERMISSION_TYPES.EDIT]: 'brandUpdate',
          [PERMISSION_TYPES.DELETE]: 'brandDelete',
        }),
      ],
    },
  ],
  [MODULES.CUSTOMER]: [
    {
      group: 'Khách hàng/nhà cung cấp',
      functions: [
        createFunction('customerManagement', 'Quản lý khách hàng', {
          [PERMISSION_TYPES.VIEW]: 'customerView',
          [PERMISSION_TYPES.CREATE]: 'customerInsert',
          [PERMISSION_TYPES.EDIT]: 'customerUpdate',
          [PERMISSION_TYPES.DELETE]: 'customerDelete',
        }),
      ],
    },
    {
      group: 'Điểm tích lũy',
      functions: [
        createFunction('pointManagement', 'Quản lý điểm tích lũy', {
          [PERMISSION_TYPES.VIEW]: 'pointView',
          [PERMISSION_TYPES.CREATE]: 'pointInsert',
          [PERMISSION_TYPES.EDIT]: 'pointUpdate',
          [PERMISSION_TYPES.DELETE]: 'pointDelete',
        }),
      ],
    },
    {
      group: 'Nhà cung cấp',
      functions: [
        createFunction('providerManagement', 'Quản lý nhà cung cấp', {
          [PERMISSION_TYPES.VIEW]: 'providerView',
          // [PERMISSION_TYPES.CREATE]: 'providerInsert',
          // [PERMISSION_TYPES.EDIT]: 'providerUpdate',
          // [PERMISSION_TYPES.DELETE]: 'providerDelete',
        }),
      ],
    },
    {
      group: 'Nhóm nhà cung cấp',
      functions: [
        createFunction('supplierGroupManagement', 'Quản lý nhóm nhà cung cấp', {
          [PERMISSION_TYPES.VIEW]: 'supplierGroupView',
          [PERMISSION_TYPES.CREATE]: 'supplierGroupInsert',
          [PERMISSION_TYPES.EDIT]: 'supplierGroupUpdate',
          [PERMISSION_TYPES.DELETE]: 'supplierGroupDelete',
        }),
      ],
    },
    {
      group: 'Nhóm khách hàng/NCC',
      functions: [
        createFunction('customerTypeManagement', 'Quản lý nhóm khách hàng/NCC', {
          [PERMISSION_TYPES.VIEW]: 'customerTypeView',
          [PERMISSION_TYPES.CREATE]: 'customerTypeCreate',
          [PERMISSION_TYPES.EDIT]: 'customerTypeEdit',
          [PERMISSION_TYPES.DELETE]: 'customerTypeDelete',
        }),
      ],
    },
  ],
  [MODULES.STOCK]: [
    {
      group: 'Nhập kho',
      functions: [
        createFunction('stockImportManagement', 'Quản lý nhập kho', {
          [PERMISSION_TYPES.VIEW]: 'stockImportView',
          [PERMISSION_TYPES.CREATE]: 'stockImportInsert',
          [PERMISSION_TYPES.EDIT]: 'stockImportUpdate',
          [PERMISSION_TYPES.DELETE]: 'stockImportDelete',
        }),
      ],
    },
    {
      group: 'Xuất kho',
      functions: [
        createFunction('stockExportManagement', 'Quản lý xuất kho', {
          [PERMISSION_TYPES.VIEW]: 'stockExportView',
          [PERMISSION_TYPES.CREATE]: 'stockExportInsert',
          [PERMISSION_TYPES.EDIT]: 'stockExportUpdate',
          [PERMISSION_TYPES.DELETE]: 'stockExportDelete',
        }),
      ],
    },
    {
      group: 'Chuyển kho',
      functions: [
        createFunction('stockTransferRequestManagement', 'Quản lý phiếu yêu cầu', {
          [PERMISSION_TYPES.VIEW]: 'stockTransferRequestView',
          [PERMISSION_TYPES.CREATE]: 'stockTransferRequestInsert',
          [PERMISSION_TYPES.EDIT]: 'stockTransferRequestUpdate',
          [PERMISSION_TYPES.DELETE]: 'stockTransferRequestDelete',
        }),
        createFunction('stockTransferSlipManagement', 'Quản lý phiếu chuyển', {
          [PERMISSION_TYPES.VIEW]: 'stockTransferView',
          [PERMISSION_TYPES.CREATE]: 'stockTransferInsert',
          [PERMISSION_TYPES.EDIT]: 'stockTransferUpdate',
          [PERMISSION_TYPES.DELETE]: 'stockTransferDelete',
        }),
      ],
    },
    {
      group: 'Nhập hàng lỗi',
      functions: [
        createFunction('stockDefectiveImportManagement', 'Nhập hàng lỗi', {
          [PERMISSION_TYPES.VIEW]: 'stockDefectiveImportView',
          [PERMISSION_TYPES.CREATE]: 'stockDefectiveImportInsert',
          [PERMISSION_TYPES.EDIT]: 'stockDefectiveImportUpdate',
          [PERMISSION_TYPES.DELETE]: 'stockDefectiveImportDelete',
        }),
      ],
    },
    {
      group: 'Xuất hàng lỗi',
      functions: [
        createFunction('stockDefectiveExportManagement', 'Xuất hàng lỗi', {
          [PERMISSION_TYPES.VIEW]: 'stockDefectiveExportView',
          [PERMISSION_TYPES.CREATE]: 'stockDefectiveExportInsert',
          [PERMISSION_TYPES.EDIT]: 'stockDefectiveExportUpdate',
          [PERMISSION_TYPES.DELETE]: 'stockDefectiveExportDelete',
        }),
      ],
    },
    {
      group: 'Phục hồi hàng lỗi',
      functions: [
        createFunction('stockDefectiveRestorationManagement', 'Phục hồi hàng lỗi', {
          [PERMISSION_TYPES.VIEW]: 'stockDefectiveRestorationView',
          [PERMISSION_TYPES.CREATE]: 'stockDefectiveRestorationInsert',
          [PERMISSION_TYPES.EDIT]: 'stockDefectiveRestorationUpdate',
          [PERMISSION_TYPES.DELETE]: 'stockDefectiveRestorationDelete',
        }),
      ],
    },
    {
      group: 'Phiếu cho mượn',
      functions: [
        createFunction('stockLendingManagement', 'Phiếu cho mượn', {
          [PERMISSION_TYPES.VIEW]: 'stockLendingView',
          [PERMISSION_TYPES.CREATE]: 'stockLendingInsert',
          [PERMISSION_TYPES.EDIT]: 'stockLendingUpdate',
          [PERMISSION_TYPES.DELETE]: 'stockLendingDelete',
        }),
      ],
    },
    {
      group: 'Đặt hàng nhập',
      functions: [
        createFunction('purchaseOrderManagement', 'Quản lý đặt hàng nhập', {
          [PERMISSION_TYPES.VIEW]: 'poView',
          [PERMISSION_TYPES.CREATE]: 'poInsert',
          [PERMISSION_TYPES.EDIT]: 'poUpdate',
          [PERMISSION_TYPES.DELETE]: 'poDelete',
        }),
        createFunction('purchaseOrderApproveManagement', 'Duyệt phiếu', {
          [PERMISSION_TYPES.ADMIN]: 'poPurchaseApprove',
        }),
        createFunction('purchaseOrderAccountantConfirmManagement', 'Xác nhận', {
          [PERMISSION_TYPES.ADMIN]: 'poAccountanApprove',
        }),
        createFunction('purchaseOrderStoreCancelManagement', 'Huỷ phiếu', {
          [PERMISSION_TYPES.ADMIN]: 'poCancel',
        }),
        createFunction('purchaseOrderImportStockManagement', 'Nhập hàng', {
          [PERMISSION_TYPES.ADMIN]: 'poImportStock',
        }),
        createFunction('purchaseOrderStoreApproveManagement', 'Cửa hàng xác nhận', {
          [PERMISSION_TYPES.ADMIN]: 'poStoreApprove',
        }),
      ],
    },
    {
      group: 'Tồn kho',
      functions: [
        createFunction('stockManagement', 'Quản lý tồn kho', {
          [PERMISSION_TYPES.VIEW]: 'stockView',
          [PERMISSION_TYPES.EXCEL]: 'stockExport',
        }),
      ],
    },
    {
      group: 'Kiểm kho',
      functions: [
        createFunction('stockCheckManagement', 'Quản lý kiểm kho', {
          [PERMISSION_TYPES.VIEW]: 'stockCheckView',
          [PERMISSION_TYPES.CREATE]: 'stockCheckInsert',
          [PERMISSION_TYPES.EDIT]: 'stockCheckUpdate',
          [PERMISSION_TYPES.DELETE]: 'stockCheckDelete',
          [PERMISSION_TYPES.ADMIN]: 'stockCheckManageAll',
        }),
        createFunction('stockCheckViewDetail', 'Xem chi tiết tồn', {
          [PERMISSION_TYPES.VIEW]: 'stockCheckViewDetail',
        }),
        createFunction('stockCheckConfirm', 'Chốt kiểm kê', {
          [PERMISSION_TYPES.ADMIN]: 'stockCheckConfirm',
        }),
      ],
    },
    {
      group: 'Giá vốn theo kỳ',
      functions: [
        createFunction(
          'inventoryCostRecalculationView',
          'Xem lô & preview dòng kết quả',
          {
            [PERMISSION_TYPES.VIEW]: 'COST_RECALCULATION_VIEW',
          },
        ),
        createFunction(
          'inventoryCostRecalculationCompute',
          'Tạo lô & chạy tính giá vốn',
          {
            [PERMISSION_TYPES.CREATE]: 'COST_RECALCULATION_COMPUTE',
          },
        ),
        createFunction(
          'inventoryCostRecalculationApply',
          'Áp dụng giá vốn vào hóa đơn',
          {
            [PERMISSION_TYPES.EDIT]: 'COST_RECALCULATION_APPLY',
          },
        ),
      ],
    },
    {
      group: 'Giá vốn đầu kỳ (opening balance)',
      functions: [
        createFunction(
          'openingBalanceCostView',
          'Xem preview tồn / lịch sử (opening balance)',
          {
            [PERMISSION_TYPES.VIEW]: 'OPENING_BALANCE_COST_VIEW',
          },
        ),
        createFunction(
          'openingBalanceCostBatch',
          'Cập nhật giá vốn đầu kỳ (batch)',
          {
            [PERMISSION_TYPES.EDIT]: 'OPENING_BALANCE_COST_EDIT',
          },
        ),
      ],
    },
    {
      group: 'Danh sách IMEI',
      functions: [
        createFunction('imeiManagement', 'Danh sách IMEI', {
          [PERMISSION_TYPES.VIEW]: 'imeiListView',
          [PERMISSION_TYPES.EXCEL]: 'imeiExport',
        }),
        
      ],
    },
    {
      group: 'Lịch sử IMEI',
      functions: [
        createFunction('imeiHistoryManagement', 'Lịch sử IMEI', {
          [PERMISSION_TYPES.VIEW]: 'imeiHistoryView',
        }),
      ],
    },
    {
      group: 'Lệnh sản xuất',
      functions: [
        createFunction('productionOrderManagement', 'Quản lý lệnh sản xuất', {
          [PERMISSION_TYPES.VIEW]: 'productionOrderView',
          [PERMISSION_TYPES.CREATE]: 'productionOrderCreate',
        }),
      ],
    },
    {
      group: 'Báo cáo xuất nhập kho',
      functions: [
        createFunction('stockSlipReportManagement', 'Báo cáo xuất nhập kho', {
          [PERMISSION_TYPES.VIEW]: 'stockSlipReportView',
          [PERMISSION_TYPES.EXCEL]: 'stockSlipReportExport',
        }),
      ],
    },
  ],
  [MODULES.SALES]: [
    {
      group: 'Hoá đơn bán lẻ',
      functions: [
        createFunction('billRetailManagement', 'Quản lý hoá đơn bán lẻ', {
          [PERMISSION_TYPES.VIEW]: 'billView',
          [PERMISSION_TYPES.CREATE]: 'billInsert',
          [PERMISSION_TYPES.EDIT]: 'billUpdate',
          [PERMISSION_TYPES.DELETE]: 'billDelete',
        }),
      ],
    },
    {
      group: 'Hoá đơn bán buôn',
      functions: [
        createFunction('billWholesaleManagement', 'Quản lý hoá đơn bán buôn', {
          [PERMISSION_TYPES.VIEW]: 'billWholesaleView',
          [PERMISSION_TYPES.CREATE]: 'billWholesaleInsert',
          [PERMISSION_TYPES.EDIT]: 'billWholesaleUpdate',
          [PERMISSION_TYPES.DELETE]: 'billWholesaleDelete',
        }),
      ],
    },
    {
      group: 'Hoá đơn giao hàng',
      functions: [
        createFunction('billDeliveryManagement', 'Quản lý hoá đơn giao hàng', {
          [PERMISSION_TYPES.VIEW]: 'billDeliveryView',
          [PERMISSION_TYPES.CREATE]: 'billDeliveryInsert',
          [PERMISSION_TYPES.EDIT]: 'billDeliveryUpdate',
          [PERMISSION_TYPES.DELETE]: 'billDeliveryDelete',
        }),
      ],
    },
    {
      group: 'Bán hàng',
      functions: [
        createFunction('billUpdateUnlimit', 'Cập nhật vượt quá số ngày', {
          [PERMISSION_TYPES.ADMIN]: 'billUpdateUnlimit',
        }),
        createFunction('billInsertReturnUnlimit', 'Trả hàng vượt quá số ngày', {
          [PERMISSION_TYPES.ADMIN]: 'billInsertReturnUnlimit',
        }),
        createFunction('billEditProductPrice', 'Chỉnh sửa giá sản phẩm', {
          [PERMISSION_TYPES.ADMIN]: 'billEditProductPrice',
        }),
        createFunction('billAllowDiscount', 'Cho phép chiết khấu bán hàng', {
          [PERMISSION_TYPES.ADMIN]: 'billAllowDiscount',
        }),
        createFunction('billAllowEditWhenEInvoiceExists', 'Cho phép chỉnh sửa khi đã có hóa đơn GTGT', {
          [PERMISSION_TYPES.ADMIN]: 'billAllowEditWhenEInvoiceExists',
        }),
      ],
    },
    {
      group: 'Hoá đơn điện tử',
      functions: [
        createFunction('einvoiceManagement', 'Quản lý hoá đơn GTGT', {
          [PERMISSION_TYPES.VIEW]: 'einvoiceView',
          [PERMISSION_TYPES.CREATE]: 'einvoiceInsert',
          [PERMISSION_TYPES.DELETE]: 'einvoiceDelete',
        }),
        createFunction('einvoiceAdjustmentManagement', 'Quản lý hoá đơn điều chỉnh GTGT', {
          [PERMISSION_TYPES.VIEW]: 'einvoiceAdjustmentView',
          [PERMISSION_TYPES.CREATE]: 'einvoiceAdjustmentInsert',
          [PERMISSION_TYPES.DELETE]: 'einvoiceAdjustmentDelete',
        }),
        createFunction('einvoiceWholesaleEmailManagement', 'Gửi email hóa đơn bán buôn', {
          [PERMISSION_TYPES.ADMIN]: 'einvoiceWholesaleEmail',
        }),
      ],
    },
  ],
  [MODULES.WARRANTY]: [
    {
      group: 'Tiếp nhận',
      functions: [
        createFunction('warrantyReceptionManagement', 'Tiếp nhận bảo hành', {
          [PERMISSION_TYPES.VIEW]: 'warrantyReceptionView',
          [PERMISSION_TYPES.CREATE]: 'warrantyReceptionInsert',
          [PERMISSION_TYPES.EDIT]: 'warrantyReceptionUpdate',
          [PERMISSION_TYPES.DELETE]: 'warrantyReceptionDelete',
        }),
        createFunction('warrantyCompleteManagement', 'Hoàn thành phiếu bảo hành', {
          [PERMISSION_TYPES.ADMIN]: 'warrantyCompleted',
        }),
        createFunction('warrantyUpdateUnlimitManagement', 'Cập nhật thông tin không giới hạn', {
          [PERMISSION_TYPES.ADMIN]: 'warrantyUpdateUnlimit',
        }),
        createFunction('warrantyUpdateServiceTypeManagement', 'Cập nhật loại dịch vụ bảo hành', {
          [PERMISSION_TYPES.ADMIN]: 'warrantyUpdateServiceType',
        }),
      ],
    },
    {
      group: 'Điều phối',
      functions: [
        createFunction('warrantyManagement', 'Điều phối bảo hành', {
          [PERMISSION_TYPES.VIEW]: 'warrantyView',
          [PERMISSION_TYPES.EDIT]: 'warrantyUpdate',
        }),
      ],
    },
    {
      group: 'Báo cáo',
      functions: [
        createFunction('warrantyReportView', 'Báo cáo tổng hợp', {
          [PERMISSION_TYPES.VIEW]: 'warrantyReportView',
          [PERMISSION_TYPES.EXCEL]: 'warrantyReportExport',
        }),
        createFunction('warrantyReportSummary', 'Báo cáo tiền', {
          [PERMISSION_TYPES.VIEW]: 'warrantyReportSummaryView',
          [PERMISSION_TYPES.EXCEL]: 'warrantyReportSummaryExport',
        }),
        createFunction('warrantyReportByEmployee', 'Báo cáo theo nhân viên', {
          [PERMISSION_TYPES.VIEW]: 'warrantyReportByEmployeeView',
          [PERMISSION_TYPES.EXCEL]: 'warrantyReportByEmployeeExport',
        }),
      ],
    },
    {
      group: 'Giải pháp',
      functions: [
        createFunction('warrantySolutionConfigManagement', 'Giải pháp', {
          [PERMISSION_TYPES.VIEW]: 'warrantySolutionConfigView',
          [PERMISSION_TYPES.CREATE]: 'warrantySolutionConfigCreate',
          [PERMISSION_TYPES.EDIT]: 'warrantySolutionConfigEdit',
          [PERMISSION_TYPES.DELETE]: 'warrantySolutionConfigDelete',
        }),
      ],
    },
    {
      group: 'Mức độ lỗi',
      functions: [
        createFunction('errorLevelManagement', 'Mức độ lỗi', {
          [PERMISSION_TYPES.VIEW]: 'errorLevelView',
          [PERMISSION_TYPES.CREATE]: 'errorLevelInsert',
          [PERMISSION_TYPES.EDIT]: 'errorLevelUpdate',
          [PERMISSION_TYPES.DELETE]: 'errorLevelDelete',
        }),
      ],
    },
    {
      group: 'Nhóm lỗi',
      functions: [
        createFunction('errorGroupManagement', 'Nhóm lỗi', {
          [PERMISSION_TYPES.VIEW]: 'errorGroupView',
          [PERMISSION_TYPES.CREATE]: 'errorGroupInsert',
          [PERMISSION_TYPES.EDIT]: 'errorGroupUpdate',
          [PERMISSION_TYPES.DELETE]: 'errorGroupDelete',
        }),
      ],
    },
    {
      group: 'Lỗi kỹ thuật',
      functions: [
        createFunction('warrantyErrorConfigManagement', 'Lỗi kỹ thuật', {
          [PERMISSION_TYPES.VIEW]: 'warrantyErrorConfigView',
          [PERMISSION_TYPES.CREATE]: 'warrantyErrorConfigCreate',
          [PERMISSION_TYPES.EDIT]: 'warrantyErrorConfigEdit',
          [PERMISSION_TYPES.DELETE]: 'warrantyErrorConfigDelete',
        }),
      ],
    },
    {
      group: 'Thiết bị kèm theo',
      functions: [
        createFunction('accompanyingEquipmentManagement', 'Thiết bị kèm theo', {
          [PERMISSION_TYPES.VIEW]: 'accompanyingEquipmentView',
          [PERMISSION_TYPES.CREATE]: 'accompanyingEquipmentInsert',
          [PERMISSION_TYPES.EDIT]: 'accompanyingEquipmentUpdate',
          [PERMISSION_TYPES.DELETE]: 'accompanyingEquipmentDelete',
        }),
      ],
    },
    {
      group: 'Loại dịch vụ',
      functions: [
        createFunction('warrantyServiceManagement', 'Quản lý loại dịch vụ bảo hành', {
          [PERMISSION_TYPES.VIEW]: 'warrantyServiceView',
          [PERMISSION_TYPES.CREATE]: 'warrantyServiceCreate',
          [PERMISSION_TYPES.EDIT]: 'warrantyServiceEdit',
          [PERMISSION_TYPES.DELETE]: 'warrantyServiceDelete',
        }),
      ],
    },
  ],
  [MODULES.TRADEIN]: [
    {
      group: 'Chương trình thu cũ - đổi mới',
      functions: [
        createFunction('tradeInProgramManagement', 'Quản lý chương trình thu cũ đổi mới', {
          [PERMISSION_TYPES.VIEW]: 'tradeInProgramView',
          [PERMISSION_TYPES.CREATE]: 'tradeInProgramInsert',
          [PERMISSION_TYPES.EDIT]: 'tradeInProgramUpdate',
          [PERMISSION_TYPES.DELETE]: 'tradeInProgramDelete',
        }),
      ],
    },
    {
      group: 'Phiếu định giá',
      functions: [
        createFunction('tradeInManagement', 'Quản lý phiếu định giá', {
          [PERMISSION_TYPES.VIEW]: 'tradeInView',
          [PERMISSION_TYPES.CREATE]: 'tradeInInsert',
          [PERMISSION_TYPES.EDIT]: 'tradeInUpdate',
          [PERMISSION_TYPES.DELETE]: 'tradeInDelete',
        }),
      ],
    },
    {
      group: 'Phiếu thu cũ',
      functions: [
        createFunction('tradeInManagement', 'Quản lý thu cũ', {
          [PERMISSION_TYPES.VIEW]: 'tradeInView',
          [PERMISSION_TYPES.CREATE]: 'tradeInInsert',
          [PERMISSION_TYPES.EDIT]: 'tradeInUpdate',
          [PERMISSION_TYPES.DELETE]: 'tradeInDelete',
        }),
        createFunction('tradeInShowAllStoreManagement', 'Phiếu định giá tất cả cửa hàng', {
          [PERMISSION_TYPES.VIEW]: 'tradeInShowAllStore',
        }),
      ],
    },
  ],
  [MODULES.ACCOUNTING]: [
    {
      group: 'Thu chi tiền mặt',
      functions: [
        createFunction('transactionManagement', 'Quản lý thu chi tiền mặt', {
          [PERMISSION_TYPES.VIEW]: 'transactionView',
          [PERMISSION_TYPES.CREATE]: 'transactionInsert',
          [PERMISSION_TYPES.EDIT]: 'transactionUpdate',
          [PERMISSION_TYPES.DELETE]: 'transactionDelete',
          [PERMISSION_TYPES.EXCEL]: 'transactionImportExcel',
        }),
        createFunction('transactionPayPrevDay', 'Thu chi lùi ngày', {
          [PERMISSION_TYPES.ADMIN]: 'transactionPayPrevDay',
        }),
      ],
    },
    {
      group: 'Công nợ',
      functions: [
        createFunction('debtProviderManagement', 'Công nợ khách hàng/nhà cung cấp', {
          [PERMISSION_TYPES.VIEW]: 'debtProviderView',
        }),
        createFunction('debtProviderDueDateManagement', 'Hạn thanh toán NCC', {
          [PERMISSION_TYPES.VIEW]: 'debtProviderDueDateView',
        }),
        createFunction('debtInstallmentManagement', 'Dịch vụ trả góp', {
          [PERMISSION_TYPES.VIEW]: 'installmentView',
          [PERMISSION_TYPES.CREATE]: 'installmentInsert',
          [PERMISSION_TYPES.EDIT]: 'installmentUpdate',
          [PERMISSION_TYPES.DELETE]: 'installmentDelete',
        }),
        createFunction('debtInstallmentBillManagement', 'Trả góp hoá đơn', {
          [PERMISSION_TYPES.VIEW]: 'debtInstallmentBillView',
          [PERMISSION_TYPES.EXCEL]: 'debtInstallmentBillExport',
        }),
        createFunction('debtInstallmentOrderManagement', 'Trả góp đơn hàng', {
          [PERMISSION_TYPES.VIEW]: 'debtInstallmentOrderView',
          [PERMISSION_TYPES.EXCEL]: 'debtInstallmentOrderExport',
        }),
        createFunction('debtCreditManagement', 'Quẹt thẻ hóa đơn', {
          [PERMISSION_TYPES.VIEW]: 'debtCreditView',
          [PERMISSION_TYPES.EXCEL]: 'debtCreditExport',
        }),
        createFunction('debtCreditOrderManagement', 'Quẹt thẻ đơn hàng', {
          [PERMISSION_TYPES.VIEW]: 'debtCreditOrderView',
          [PERMISSION_TYPES.EXCEL]: 'debtCreditOrderExport',
        }),
        createFunction('debtShipFeeOrderManagement', 'Phí ship đơn hàng', {
          [PERMISSION_TYPES.VIEW]: 'debtShipFeeOrderView',
          [PERMISSION_TYPES.EXCEL]: 'debtShipFeeOrderExport',
        }),
        createFunction('debtWarrantyInstallmentManagement', 'Trả góp bảo hành', {
          [PERMISSION_TYPES.VIEW]: 'debtWarrantyInstallmentView',
          [PERMISSION_TYPES.EXCEL]: 'debtWarrantyInstallmentExport',
        }),
      ],
    },
    {
      group: 'Tài khoản kế toán',
      functions: [
        createFunction('accountantManagement', 'Tài khoản kế toán', {
          [PERMISSION_TYPES.VIEW]: 'accountantView',
          [PERMISSION_TYPES.CREATE]: 'accountantInsert',
          [PERMISSION_TYPES.EDIT]: 'accountantUpdate',
          [PERMISSION_TYPES.DELETE]: 'accountantDelete',
        }),
      ],
    },
    {
      group: 'Danh mục thu chi',
      functions: [
        createFunction('transactionCateManagement', 'Danh mục thu chi', {
          [PERMISSION_TYPES.VIEW]: 'transCateView',
          [PERMISSION_TYPES.CREATE]: 'transCateInsert',
          [PERMISSION_TYPES.EDIT]: 'transCateDelete',//Trường hợp đặc biệt trong db
          [PERMISSION_TYPES.DELETE]: 'transactionCateDelete',
        }),
      ],
    },
    {
      group: 'Giải ngân',
      functions: [
        createFunction('disbursementManagement', 'Giải ngân công nợ', {
          [PERMISSION_TYPES.VIEW]: 'disbursementView',
          [PERMISSION_TYPES.CREATE]: 'disbursementInsert',
        }),
        createFunction('disbursementConfigManagement', 'Cấu hình nhà giải ngân', {
          [PERMISSION_TYPES.VIEW]: 'disbursementConfigView',
          [PERMISSION_TYPES.CREATE]: 'disbursementConfigInsert',
          [PERMISSION_TYPES.EDIT]: 'disbursementConfigUpdate',
          [PERMISSION_TYPES.DELETE]: 'disbursementConfigDelete',
        }),
      ],
    },
    {
      group: 'Phiếu yêu cầu duyệt chi',
      functions: [
        createFunction('approvalManagement', 'Quản lý phiếu duyệt chi', {
          [PERMISSION_TYPES.VIEW]: 'approvalView',
          [PERMISSION_TYPES.CREATE]: 'approvalInsert',
          [PERMISSION_TYPES.EDIT]: 'approvalUpdate',
          [PERMISSION_TYPES.DELETE]: 'approvalDelete',
        }),
        createFunction('approvalPaidManagement', 'Cập nhật thanh toán', {
          [PERMISSION_TYPES.ADMIN]: 'approvalPaid',
        }),
        createFunction('approvalApproveManagement', 'Duyệt phiếu', {
          [PERMISSION_TYPES.ADMIN]: 'approvalApprove',
        }),
        createFunction('approvalCancelManagement', 'Hủy phiếu', {
          [PERMISSION_TYPES.ADMIN]: 'approvalCancel',
        }),
        createFunction('approvalReturnManagement', 'Trả phiếu', {
          [PERMISSION_TYPES.ADMIN]: 'approvalReturn',
        }),
      ],
    },
  ],
  [MODULES.REWARD]: [
    {
      group: 'Hoa hồng',
      functions: [
        createFunction('rewardManagement', 'Quản lý nhóm sản phẩm hoa hồng', {
          [PERMISSION_TYPES.VIEW]: 'rewardProductCategoryView',
          [PERMISSION_TYPES.CREATE]: 'rewardProductCategoryInsert',
          [PERMISSION_TYPES.EDIT]: 'rewardProductCategoryUpdate',
          [PERMISSION_TYPES.DELETE]: 'rewardProductCategoryDelete',
        }),
        createFunction('rewardProgramManagement', 'Quản lý chương trình thưởng hoa hồng', {
          [PERMISSION_TYPES.VIEW]: 'rewardProgramView',
          [PERMISSION_TYPES.CREATE]: 'rewardProgramInsert',
          [PERMISSION_TYPES.EDIT]: 'rewardProgramUpdate',
          [PERMISSION_TYPES.DELETE]: 'rewardProgramDelete',
        }),
        createFunction('rewardDetailManagement', 'Quản lý cộng trừ khác hoa hồng', {
          [PERMISSION_TYPES.VIEW]: 'rewardDetailView',
          [PERMISSION_TYPES.CREATE]: 'rewardDetailInsert',
          [PERMISSION_TYPES.EDIT]: 'rewardDetailUpdate',
          [PERMISSION_TYPES.DELETE]: 'rewardDetailDelete',
        }),
        createFunction('rewardCheckManagement', 'Kiểm tra sản phẩm tính hoa hồng', {
          [PERMISSION_TYPES.VIEW]: 'rewardCheckView',
        }),
      ],
    },
  ],
  [MODULES.REPORT]: [
    {
      group: 'Kế toán',
      functions: [
        createFunction('accountingReportAllManagement', 'Tổng hợp thu chi theo cửa hàng', {
          [PERMISSION_TYPES.VIEW]: 'reportTransactionStoreView',
          [PERMISSION_TYPES.EXCEL]: 'reportTransactionStoreExport',
        }),
      ],
    },
    {
      group: 'Hoa hồng cửa hàng',
      functions: [
        createFunction('rewardReportAllManagement', 'Báo cáo hoa hồng cửa hàng', {
          [PERMISSION_TYPES.VIEW]: 'rrViewAll',
          [PERMISSION_TYPES.EXCEL]: 'rrExportAll',
        }),
      ],
    },
    {
      group: 'Hoa hồng CSKH',
      functions: [
        createFunction('rewardCRReportAllManagement', 'Báo cáo hoa hồng CSKH', {
          [PERMISSION_TYPES.VIEW]: 'crViewAll',
          [PERMISSION_TYPES.EXCEL]: 'crExportAll',
        }),
      ],
    },
    {
      group: 'Báo cáo XNT',
      functions: [
        createFunction('inventorySummaryReportManagement', 'Báo cáo XNT', {
          [PERMISSION_TYPES.VIEW]: 'inventorySummaryReportView',
          [PERMISSION_TYPES.EXCEL]: 'inventorySummaryReportExport',
        }),
      ],
    },
    {
      group: 'Báo cáo doanh thu theo sản phẩm',
      functions: [
        createFunction('productRevenueReportManagement', 'Báo cáo doanh thu theo sản phẩm', {
          [PERMISSION_TYPES.VIEW]: 'productRevenueReportView',
          [PERMISSION_TYPES.EXCEL]: 'productRevenueReportExport',
        }),
      ],
    },
    {
      group: 'Báo cáo lãi lỗ',
      functions: [
        createFunction('billRevenueReportManagement', 'Báo cáo theo hoá đơn', {
          [PERMISSION_TYPES.VIEW]: 'billRevenueReportView',
          [PERMISSION_TYPES.EXCEL]: 'billRevenueReportExport',
        }),
        createFunction('productImeiRevenueReportManagement', 'Báo cáo theo sản phẩm IMEI', {
          [PERMISSION_TYPES.VIEW]: 'productImeiRevenueReportView',
          [PERMISSION_TYPES.EXCEL]: 'productImeiRevenueReportExport',
        }),
      ],
    },
    {
      group: 'Báo cáo bán hàng',
      functions: [
        createFunction('salesReportV2Management', 'Báo cáo bán hàng', {
          [PERMISSION_TYPES.VIEW]: 'SALES_REPORT_VIEW',
          [PERMISSION_TYPES.EXCEL]: 'SALES_REPORT_EXPORT',
        }),
      ],
    },
  ],
  [MODULES.CONFIG]: [
    {
      group: 'Cửa hàng',
      functions: [
        createFunction('storeManagement', 'Quản lý cửa hàng', {
          [PERMISSION_TYPES.VIEW]: 'storeView',
          [PERMISSION_TYPES.CREATE]: 'storeInsert',
          [PERMISSION_TYPES.EDIT]: 'storeUpdate',
          [PERMISSION_TYPES.DELETE]: 'storeDelete',
        }),
        createFunction('companyManagement', 'Quản lý doanh nghiệp', {
          [PERMISSION_TYPES.VIEW]: 'companyView',
          [PERMISSION_TYPES.CREATE]: 'companyInsert',
          [PERMISSION_TYPES.EDIT]: 'companyUpdate',
          [PERMISSION_TYPES.DELETE]: 'companyDelete',
        }),
        createFunction('transferStoreFormManagement', 'Quản lý phiếu chuyển cửa hàng', {
          [PERMISSION_TYPES.VIEW]: 'transferStoreFormView',
          [PERMISSION_TYPES.CREATE]: 'transferStoreFormInsert',
          [PERMISSION_TYPES.EDIT]: 'transferStoreFormUpdate',
          [PERMISSION_TYPES.DELETE]: 'transferStoreFormDelete',
        }),
      ],
    },
    {
      group: 'Tài khoản',
      functions: [
        createFunction('employeeManagement', 'Quản lý nhân sự', {
          [PERMISSION_TYPES.VIEW]: 'employeeView',
          [PERMISSION_TYPES.CREATE]: 'employeeInsert',
          [PERMISSION_TYPES.EDIT]: 'employeeUpdate',
          [PERMISSION_TYPES.DELETE]: 'employeeDelete',
        }),
        createFunction('userManagement', 'Quản lý người dùng', {
          [PERMISSION_TYPES.VIEW]: 'userView',
          [PERMISSION_TYPES.CREATE]: 'userInsert',
          [PERMISSION_TYPES.EDIT]: 'userUpdate',
          [PERMISSION_TYPES.DELETE]: 'userDelete',
        }),
        createFunction('roleManagement', 'Quản lý bảo mật & phân quyền', {
          [PERMISSION_TYPES.VIEW]: 'roleView',
          [PERMISSION_TYPES.CREATE]: 'roleInsert',
          [PERMISSION_TYPES.EDIT]: 'roleUpdate',
          [PERMISSION_TYPES.DELETE]: 'roleDelete',
        }),
      ],
    },
    {
      group: 'Khuyến mãi',
      functions: [
        createFunction('voucherManagement', 'Quản lý voucher sản phẩm', {
          [PERMISSION_TYPES.VIEW]: 'voucherView',
          [PERMISSION_TYPES.CREATE]: 'voucherInsert',
          [PERMISSION_TYPES.EDIT]: 'voucherUpdate',
          [PERMISSION_TYPES.DELETE]: 'voucherDelete',
        }),
      ],
    },
    {
      group: 'Ngành hàng',
      functions: [
        createFunction('productAttachManagement', 'Quản lý bộ phụ kiện tặng kèm', {
          [PERMISSION_TYPES.VIEW]: 'proAcctachView',
          [PERMISSION_TYPES.CREATE]: 'proAcctachInsert',
          [PERMISSION_TYPES.EDIT]: 'proAcctachUpdate',
          [PERMISSION_TYPES.DELETE]: 'proAcctachDelete',
        }),
        createFunction('productPromotionManagement', 'Quản lý bộ phụ kiện khuyến mãi', {
          [PERMISSION_TYPES.VIEW]: 'proPromotionView',
          [PERMISSION_TYPES.CREATE]: 'proPromotionInsert',
          [PERMISSION_TYPES.EDIT]: 'proPromotionUpdate',
          [PERMISSION_TYPES.DELETE]: 'proPromotionDelete',
        }),
        createFunction('warrantyPackageManagement', 'Quản lý gói bảo hành', {
          [PERMISSION_TYPES.VIEW]: 'warrantyPackageView',
          [PERMISSION_TYPES.CREATE]: 'warrantyPackageInsert',
          [PERMISSION_TYPES.EDIT]: 'warrantyPackageUpdate',
          [PERMISSION_TYPES.DELETE]: 'warrantyPackageDelete',
        }),
        createFunction('discountManagement', 'Quản lý giảm giám khuyến mãi', {
          [PERMISSION_TYPES.VIEW]: 'discountView',
          [PERMISSION_TYPES.CREATE]: 'discountInsert',
          [PERMISSION_TYPES.EDIT]: 'discountUpdate',
          [PERMISSION_TYPES.DELETE]: 'discountDelete',
        }),
        createFunction('flexibleComboManagement', 'Quản lý combo linh hoạt', {
          [PERMISSION_TYPES.VIEW]: 'flexibleComboView',
          [PERMISSION_TYPES.CREATE]: 'flexibleComboInsert',
          [PERMISSION_TYPES.EDIT]: 'flexibleComboUpdate',
          [PERMISSION_TYPES.DELETE]: 'flexibleComboDelete',
        }),
        createFunction('dealsheetManagement', 'Quản lý deal sheet', {
          [PERMISSION_TYPES.VIEW]: 'dealsheetView',
          [PERMISSION_TYPES.CREATE]: 'dealsheetInsert',
          [PERMISSION_TYPES.EDIT]: 'dealsheetUpdate',
          [PERMISSION_TYPES.DELETE]: 'dealsheetDelete',
          [PERMISSION_TYPES.EXCEL]: 'dealsheetExport',
        }),
        // createFunction('couponProgramManagement', 'Quản lý coupon', {
        //   [PERMISSION_TYPES.VIEW]: 'couponView',
        //   [PERMISSION_TYPES.CREATE]: 'couponInsert',
        //   [PERMISSION_TYPES.EDIT]: 'couponUpdate',
        //   [PERMISSION_TYPES.DELETE]: 'couponDelete',
        // }),
      ],
    },
    {
      group: 'Cấu hình duyệt chi',
      functions: [
        createFunction('approvalConfigManagement', 'Quản lý cấu hình duyệt chi', {
          [PERMISSION_TYPES.VIEW]: 'approvalConfigView',
          [PERMISSION_TYPES.CREATE]: 'approvalConfigInsert',
          [PERMISSION_TYPES.EDIT]: 'approvalConfigUpdate',
          [PERMISSION_TYPES.DELETE]: 'approvalConfigDelete',
        }),
      ],
    },
    {
      group: 'Cài đặt',
      functions: [
        createFunction('settingManagement', 'Cài đặt hệ thống', {
          [PERMISSION_TYPES.VIEW]: 'settingView',
          [PERMISSION_TYPES.EDIT]: 'settingUpdate',
        }),
      ],
    },
    {
      group: 'Kiểm soát truy cập IP',
      functions: [
        createFunction('ipWhitelistManagement', 'IP Whitelist', {
          [PERMISSION_TYPES.VIEW]: 'ipWhitelistView',
          [PERMISSION_TYPES.CREATE]: 'ipWhitelistInsert',
          [PERMISSION_TYPES.EDIT]: 'ipWhitelistUpdate',
          [PERMISSION_TYPES.DELETE]: 'ipWhitelistDelete',
        }),
        createFunction('ipBypassExceptionManagement', 'Ngoại lệ bypass IP', {
          [PERMISSION_TYPES.VIEW]: 'ipBypassView',
          [PERMISSION_TYPES.CREATE]: 'ipBypassInsert',
          [PERMISSION_TYPES.EDIT]: 'ipBypassUpdate',
          [PERMISSION_TYPES.DELETE]: 'ipBypassDelete',
        }),
      ],
    },
  ],
  [MODULES.ORDER]: [
    {
      group: 'Đơn hàng',
      functions: [
        createFunction('orderManagement', 'Quản lý đơn hàng', {
          [PERMISSION_TYPES.VIEW]: 'orderView',
          [PERMISSION_TYPES.CREATE]: 'orderInsert',
          [PERMISSION_TYPES.EDIT]: 'orderUpdate',
          [PERMISSION_TYPES.DELETE]: 'orderDelete',
        }),
        createFunction('orderUpdateAccounting', 'Cập nhật cho kế toán', {
          [PERMISSION_TYPES.ADMIN]: 'orderUpdateAccounting',
        }),
      ],
    },
    {
      group: 'Đơn sàn',
      functions: [
        createFunction('ecomOrderManagement', 'Quản lý đơn sàn', {
          [PERMISSION_TYPES.VIEW]: 'ecomOrderView',
          [PERMISSION_TYPES.CREATE]: 'ecomOrderInsert',
          [PERMISSION_TYPES.EDIT]: 'ecomOrderUpdate',
          [PERMISSION_TYPES.DELETE]: 'ecomOrderDelete',
        }),
      ],
    },
    {
      group: 'Đơn đặt trước',
      functions: [
        createFunction('preOrderManagement', 'Quản lý đơn đặt trước', {
          [PERMISSION_TYPES.VIEW]: 'preOrderView',
          [PERMISSION_TYPES.CREATE]: 'preOrderInsert',
          [PERMISSION_TYPES.EDIT]: 'preOrderUpdate',
          [PERMISSION_TYPES.DELETE]: 'preOrderDelete',
        }),
      ],
    },
    {
      group: 'Nguồn đơn hàng',
      functions: [
        createFunction('orderSourceManagement', 'Quản lý nguồn đơn hàng', {
          [PERMISSION_TYPES.VIEW]: 'orderSourceView',
          [PERMISSION_TYPES.CREATE]: 'orderSourceInsert',
          [PERMISSION_TYPES.EDIT]: 'orderSourceUpdate',
          [PERMISSION_TYPES.DELETE]: 'orderSourceDelete',
        }),
      ],
    },
  ],
  [MODULES.PLATFORM]: [
    {
      group: 'Kênh bán',
      functions: [
        createFunction('platformIntegration', 'Quản lý kênh bán', {
          [PERMISSION_TYPES.VIEW]: 'platformIntegrationView',
          [PERMISSION_TYPES.CREATE]: 'platformIntegrationInsert',
          [PERMISSION_TYPES.EDIT]: 'platformIntegrationUpdate',
          [PERMISSION_TYPES.DELETE]: 'platformIntegrationDelete',
        }),
        createFunction('platformProductManagement', 'Quản lý sản phẩm kênh bán', {
          [PERMISSION_TYPES.ADMIN]: 'platformProductManage',
        }),
        createFunction('platformOrderManagement', 'Quản lý đơn hàng kênh bán', {
          [PERMISSION_TYPES.ADMIN]: 'platformOrderManage',
        }),
        createFunction('platformComplaintManagement', 'Quản lý đơn khiếu nại kênh bán', {
          [PERMISSION_TYPES.ADMIN]: 'platformComplaintManage',
        }),
        createFunction('platformReconciliationManagement', 'Đối soát đơn hàng kênh bán', {
          [PERMISSION_TYPES.ADMIN]: 'platformReconciliationManage',
        }),
        createFunction('platformPickListReportManagement', 'Báo cáo Pick-list RTS', {
          [PERMISSION_TYPES.ADMIN]: 'platformPickListReportManage',
        }),
        createFunction('platformOrderReportManagement', 'Báo cáo đơn hàng kênh bán', {
          [PERMISSION_TYPES.ADMIN]: 'platformOrderReportManage',
        }),
        createFunction('platformOrderFunnelReportManagement', 'Báo cáo phễu đơn (legacy)', {
          [PERMISSION_TYPES.ADMIN]: 'platformOrderFunnelReportManage',
        }),
        createFunction('platformByMarketplaceReportManagement', 'Báo cáo theo marketplace (legacy)', {
          [PERMISSION_TYPES.ADMIN]: 'platformByMarketplaceReportManage',
        }),
        createFunction('platformProfitLossReportManagement', 'Báo cáo lãi lỗ kênh bán', {
          [PERMISSION_TYPES.ADMIN]: 'platformProfitLossReportManage',
        }),
        createFunction('platformByProductReportManagement', 'Báo cáo theo sản phẩm kênh bán (legacy)', {
          [PERMISSION_TYPES.ADMIN]: 'platformByProductReportManage',
        }),
      ],
    },
  ],
};
